var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { showLoader, showNotification } from "../../../redux/commonSlice";
import { createAPI, getByIdAPI, getFileAPI, getListAPI, setState, updateAPI, uploadAttachmentAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { ServiceEstimateKeys } from "../../serviceEstimateM3/services/entity";
import { fieldFailureAttachmentSingleValue, fieldFailureReportCreateAttachment, fieldFailureReportsDetailCreate, fieldFailureReportsDetailGetByIdAPI, fieldFailureReportsDetailUpdateByIdAPI, fieldFailureReportsDownloadURL, FieldFailureReportsKeys, fieldFailureReportsManualSearchURL, fieldFailureReportsPagingURL, fieldFailureReportsTemperatureConditionsListAPI, fieldFailureReportSubmit, fieldFailureReportsWarrantyPartDetails, getBranchListUrl, getPartListUrl, repairTypeListURL } from "./entity";
var dispatch = store.dispatch;
export var FieldFailureReportsGetAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _res$payload2, _res$payload3, _res$payload4, _a, key, _b, request, _c, url, res, FileAttachments, data;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsDetailGetByIdAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                FileAttachments = __spreadArray([], ((res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.Attachments) || []), true);
                data = (res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value).data;
                return [2 /*return*/, _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value), {}, {
                        data: _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.value) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.data), {}, {
                            ParamsBeforeRepairExpanded: true,
                            ParamsWhileRepairDataExpanded: true,
                            FileAttachments: FileAttachments
                        })
                    })];
        }
    });
}); };
export var FieldFailureReportSubmitAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res, _request$onClose, _res$payload6;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.update : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportSubmit(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(updateAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload5 = res.payload) !== null && _res$payload5 !== void 0 && _res$payload5.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Updated Successfully",
                        type: "success"
                    }));
                    /**
                     * Navigating user to catalog dashboard
                     */
                    request === null || request === void 0 || (_request$onClose = request.onClose) === null || _request$onClose === void 0 || _request$onClose.call(request);
                    window.location.href = '/fieldFailureReports';
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.error,
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
        }
    });
}); };
export var fieldFailureReportsCountAPI = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _allRes$payload$value, _allRes$payload, _openRes$payload$valu, _openRes$payload, _submittedRes$payload, _submittedRes$payload2, _revertedRes$payload$, _revertedRes$payload, _closedRes$payload$va, _closedRes$payload, _resubmittedRes$paylo, _resubmittedRes$paylo2, _a, allRes, openRes, submittedRes, revertedRes, closedRes, resubmittedRes, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                        key: FieldFailureReportsKeys.count,
                        url: fieldFailureReportsPagingURL
                    })), dispatch(getByIdAPI({
                        key: FieldFailureReportsKeys.count,
                        url: fieldFailureReportsPagingURL,
                        request: {
                            status: 'Open'
                        }
                    })), dispatch(getByIdAPI({
                        key: FieldFailureReportsKeys.count,
                        url: fieldFailureReportsPagingURL,
                        request: {
                            status: 'SubmittedByDealer'
                        }
                    })), dispatch(getByIdAPI({
                        key: FieldFailureReportsKeys.count,
                        url: fieldFailureReportsPagingURL,
                        request: {
                            status: 'RevertedByASM'
                        }
                    })), dispatch(getByIdAPI({
                        key: FieldFailureReportsKeys.count,
                        url: fieldFailureReportsPagingURL,
                        request: {
                            status: 'Closed'
                        }
                    })), dispatch(getByIdAPI({
                        key: FieldFailureReportsKeys.count,
                        url: fieldFailureReportsPagingURL,
                        request: {
                            status: 'ResubmittedToASM'
                        }
                    }))])];
            case 1:
                _a = _b.sent(), allRes = _a[0], openRes = _a[1], submittedRes = _a[2], revertedRes = _a[3], closedRes = _a[4], resubmittedRes = _a[5];
                console.log("result", submittedRes);
                result = dispatch(setState({
                    key: FieldFailureReportsKeys.count,
                    value: {
                        all: (_allRes$payload$value = allRes === null || allRes === void 0 || (_allRes$payload = allRes.payload) === null || _allRes$payload === void 0 || (_allRes$payload = _allRes$payload.value) === null || _allRes$payload === void 0 ? void 0 : _allRes$payload.count) !== null && _allRes$payload$value !== void 0 ? _allRes$payload$value : 0,
                        open: (_openRes$payload$valu = openRes === null || openRes === void 0 || (_openRes$payload = openRes.payload) === null || _openRes$payload === void 0 || (_openRes$payload = _openRes$payload.value) === null || _openRes$payload === void 0 ? void 0 : _openRes$payload.count) !== null && _openRes$payload$valu !== void 0 ? _openRes$payload$valu : 0,
                        submitted: (_submittedRes$payload = submittedRes === null || submittedRes === void 0 || (_submittedRes$payload2 = submittedRes.payload) === null || _submittedRes$payload2 === void 0 || (_submittedRes$payload2 = _submittedRes$payload2.value) === null || _submittedRes$payload2 === void 0 ? void 0 : _submittedRes$payload2.count) !== null && _submittedRes$payload !== void 0 ? _submittedRes$payload : 0,
                        reverted: (_revertedRes$payload$ = revertedRes === null || revertedRes === void 0 || (_revertedRes$payload = revertedRes.payload) === null || _revertedRes$payload === void 0 || (_revertedRes$payload = _revertedRes$payload.value) === null || _revertedRes$payload === void 0 ? void 0 : _revertedRes$payload.count) !== null && _revertedRes$payload$ !== void 0 ? _revertedRes$payload$ : 0,
                        closed: (_closedRes$payload$va = closedRes === null || closedRes === void 0 || (_closedRes$payload = closedRes.payload) === null || _closedRes$payload === void 0 || (_closedRes$payload = _closedRes$payload.value) === null || _closedRes$payload === void 0 ? void 0 : _closedRes$payload.count) !== null && _closedRes$payload$va !== void 0 ? _closedRes$payload$va : 0,
                        resubmitted: (_resubmittedRes$paylo = resubmittedRes === null || resubmittedRes === void 0 || (_resubmittedRes$paylo2 = resubmittedRes.payload) === null || _resubmittedRes$paylo2 === void 0 || (_resubmittedRes$paylo2 = _resubmittedRes$paylo2.value) === null || _resubmittedRes$paylo2 === void 0 ? void 0 : _resubmittedRes$paylo2.count) !== null && _resubmittedRes$paylo !== void 0 ? _resubmittedRes$paylo : 0
                    }
                }));
                return [2 /*return*/, result.payload.value];
        }
    });
}); };
export var fieldFailureReportsPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.log("in--> 2");
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsPagingURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var fieldFailureReportsManualSearchAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.ManualSearchGetData : _a, _b = params.request, request = _b === void 0 ? {
                    ChannelId: ''
                } : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsManualSearchURL : _c;
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                if ((res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 || (_res$payload8 = _res$payload8.value) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.data) === undefined) {
                    console.log("error--->");
                    dispatch(showNotification({
                        isOpen: true,
                        Message: "Record not found",
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var downloadAttachmentFfrAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload10, _a, key, _b, request, _c, url, res, _res$payload11;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? '' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsDownloadURL(request) : _c;
                return [4 /*yield*/, dispatch(getFileAPI({
                        key: key,
                        url: url,
                        request: request,
                        headers: {}
                    }))];
            case 1:
                res = _d.sent();
                if ((res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.data) instanceof Blob) {
                    return [2 /*return*/, res.payload];
                }
                else {
                    console.error("Invalid response type: expected Blob, received", typeof (res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.data));
                    return [2 /*return*/, null];
                }
                return [2 /*return*/];
        }
    });
}); };
export var fieldFailureReportsWarrantyPartAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload12, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.GetWarrantyList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsWarrantyPartDetails(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.value];
        }
    });
}); };
export var getTemperatureConditionList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload13, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.tempCondList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsTemperatureConditionsListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.value];
        }
    });
}); };
export var UploadAttachmentAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$request, _file$size, _params$state$id, _params$state, _params$request2, file, fileSize, requestData, _a, key, _b, url, uploadResponse, attachmentId, schemaId, uploadUrl, singleValueKey, finalResponse;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                file = params === null || params === void 0 || (_params$request = params.request) === null || _params$request === void 0 ? void 0 : _params$request.data;
                if (!file) {
                    console.error("No file provided in request");
                    return [2 /*return*/, null];
                }
                fileSize = (_file$size = file === null || file === void 0 ? void 0 : file.size) !== null && _file$size !== void 0 ? _file$size : file === null || file === void 0 ? void 0 : file.Size;
                requestData = {
                    FieldFailureReportId: (_params$state$id = params === null || params === void 0 || (_params$state = params.state) === null || _params$state === void 0 ? void 0 : _params$state.id) !== null && _params$state$id !== void 0 ? _params$state$id : params === null || params === void 0 || (_params$request2 = params.request) === null || _params$request2 === void 0 ? void 0 : _params$request2.id,
                    AttachmentId: "",
                    Remark: "",
                    Size: fileSize,
                    EntityId: "",
                    IsChecksheetFilled: 1,
                    IsDeleted: 0
                };
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.update : _a, _b = params.url, url = _b === void 0 ? fieldFailureReportCreateAttachment : _b;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: requestData
                    }))];
            case 1:
                uploadResponse = _c.sent();
                attachmentId = uploadResponse.payload.value.data.FieldFailureReportAttachmentId;
                schemaId = uploadResponse.payload.value.data.SchemaId;
                uploadUrl = fieldFailureAttachmentSingleValue(attachmentId, schemaId);
                singleValueKey = FieldFailureReportsKeys.getValue;
                return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                        key: singleValueKey,
                        request: {
                            data: file,
                            systemname: 'FieldFailureReportAttachment'
                        },
                        url: uploadUrl
                    }))];
            case 2:
                finalResponse = _c.sent();
                return [2 /*return*/, finalResponse.payload.value];
        }
    });
}); };
export var UploadMultipleAttachmentAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$request3, _params$state2, _params$state$id2, _params$state3, _params$request4, file, fileSize, remarkValue, requestData, _a, key, _b, url, uploadResponse, attachmentId, schemaId, uploadUrl, singleValueKey, finalResponse;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                file = params === null || params === void 0 || (_params$request3 = params.request) === null || _params$request3 === void 0 ? void 0 : _params$request3.data;
                if (!file) {
                    console.error("No file provided in request");
                    return [2 /*return*/, null];
                }
                fileSize = file === null || file === void 0 ? void 0 : file.size;
                remarkValue = (_params$state2 = params.state) === null || _params$state2 === void 0 || (_params$state2 = _params$state2.FileAttachments) === null || _params$state2 === void 0 || (_params$state2 = _params$state2.find(function (it) { return it.id == (file === null || file === void 0 ? void 0 : file.name); })) === null || _params$state2 === void 0 ? void 0 : _params$state2.Remark;
                requestData = {
                    FieldFailureReportId: (_params$state$id2 = params === null || params === void 0 || (_params$state3 = params.state) === null || _params$state3 === void 0 ? void 0 : _params$state3.id) !== null && _params$state$id2 !== void 0 ? _params$state$id2 : params === null || params === void 0 || (_params$request4 = params.request) === null || _params$request4 === void 0 ? void 0 : _params$request4.id,
                    Remark: remarkValue,
                    Size: fileSize,
                    IsChecksheetFilled: 0,
                    IsDeleted: 0
                };
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.update : _a, _b = params.url, url = _b === void 0 ? fieldFailureReportCreateAttachment : _b;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: requestData
                    }))];
            case 1:
                uploadResponse = _c.sent();
                attachmentId = uploadResponse.payload.value.data.FieldFailureReportAttachmentId;
                schemaId = uploadResponse.payload.value.data.SchemaId;
                uploadUrl = fieldFailureAttachmentSingleValue(attachmentId, schemaId);
                singleValueKey = FieldFailureReportsKeys.getValue;
                return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                        key: singleValueKey,
                        request: {
                            data: file,
                            systemname: 'FieldFailureReportAttachment'
                        },
                        url: uploadUrl
                    }))];
            case 2:
                finalResponse = _c.sent();
                return [2 /*return*/, finalResponse === null || finalResponse === void 0 ? void 0 : finalResponse.payload.value];
        }
    });
}); };
export var getFieldFailureReportsUpdateAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$ParamsAfterR, _request$ParamsBefore, _res$payload14, _a, key, _b, request, _c, url, paramsAfterRepairData, paramsBeforeRepairData, reqData, res, _res$payload15;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.update : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsDetailUpdateByIdAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                paramsAfterRepairData = (_request$ParamsAfterR = request.ParamsAfterRepairData) === null || _request$ParamsAfterR === void 0 ? void 0 : _request$ParamsAfterR.map(function (item) {
                    var _item$IsBeforeRepair;
                    return _objectSpread(_objectSpread({}, item), {}, {
                        IsBeforeRepair: (_item$IsBeforeRepair = item.IsBeforeRepair) !== null && _item$IsBeforeRepair !== void 0 ? _item$IsBeforeRepair : 0
                    });
                });
                paramsBeforeRepairData = (_request$ParamsBefore = request.ParamsBeforeRepairData) === null || _request$ParamsBefore === void 0 ? void 0 : _request$ParamsBefore.map(function (item) {
                    var _item$IsBeforeRepair2;
                    return _objectSpread(_objectSpread({}, item), {}, {
                        IsBeforeRepair: (_item$IsBeforeRepair2 = item.IsBeforeRepair) !== null && _item$IsBeforeRepair2 !== void 0 ? _item$IsBeforeRepair2 : 1
                    });
                });
                reqData = _objectSpread(_objectSpread({}, request), {}, {
                    ParamsAfterRepairData: paramsAfterRepairData,
                    ParamsBeforeRepairData: paramsBeforeRepairData,
                    Attachments: request === null || request === void 0 ? void 0 : request.FileAttachments.map(function (item) { return _objectSpread({}, item); })
                });
                return [4 /*yield*/, dispatch(updateAPI({
                        key: key,
                        url: url,
                        request: reqData
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload14 = res.payload) !== null && _res$payload14 !== void 0 && _res$payload14.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Updated Successfully",
                        type: "success"
                    }));
                    /**
                     * Navigating user to catalog dashboard
                     */
                    window.location.href = '/fieldFailureReports';
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.error,
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
        }
    });
}); };
export var fieldFailureReportsCreateAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$ParamsAfterR2, _request$ParamsBefore2, _res$payload16, _res$payload18, _a, key, _b, request, _c, url, paramsAfterRepairData, paramsBeforeRepairData, reqData, res, _res$payload17;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.create : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsDetailCreate : _c;
                paramsAfterRepairData = (_request$ParamsAfterR2 = request.ParamsAfterRepairData) === null || _request$ParamsAfterR2 === void 0 ? void 0 : _request$ParamsAfterR2.map(function (item) {
                    var _item$IsBeforeRepair3;
                    return _objectSpread(_objectSpread({}, item), {}, {
                        IsBeforeRepair: (_item$IsBeforeRepair3 = item.IsBeforeRepair) !== null && _item$IsBeforeRepair3 !== void 0 ? _item$IsBeforeRepair3 : 0
                    });
                });
                paramsBeforeRepairData = (_request$ParamsBefore2 = request.ParamsBeforeRepairData) === null || _request$ParamsBefore2 === void 0 ? void 0 : _request$ParamsBefore2.map(function (item) {
                    var _item$IsBeforeRepair4;
                    return _objectSpread(_objectSpread({}, item), {}, {
                        IsBeforeRepair: (_item$IsBeforeRepair4 = item.IsBeforeRepair) !== null && _item$IsBeforeRepair4 !== void 0 ? _item$IsBeforeRepair4 : 1
                    });
                });
                reqData = _objectSpread(_objectSpread({}, request), {}, {
                    ParamsAfterRepairData: paramsAfterRepairData,
                    ParamsBeforeRepairData: paramsBeforeRepairData
                });
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: reqData
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload16 = res.payload) !== null && _res$payload16 !== void 0 && (_res$payload16 = _res$payload16.value) !== null && _res$payload16 !== void 0 && _res$payload16.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Created Successfully",
                        type: "success"
                    }));
                    /**
                     * Navigating user to catalog dashboard
                     */
                    window.location.href = '/fieldFailureReports';
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: res === null || res === void 0 || (_res$payload17 = res.payload) === null || _res$payload17 === void 0 ? void 0 : _res$payload17.error,
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 || (_res$payload18 = res.payload) === null || _res$payload18 === void 0 ? void 0 : _res$payload18.value];
        }
    });
}); };
export var getPartListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload19, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ServiceEstimateKeys.PartList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getPartListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload19 = res.payload) === null || _res$payload19 === void 0 ? void 0 : _res$payload19.value];
        }
    });
}); };
export var getBranchListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload20, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'branchList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getBranchListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload20 = res.payload) === null || _res$payload20 === void 0 || (_res$payload20 = _res$payload20.value) === null || _res$payload20 === void 0 ? void 0 : _res$payload20.data];
        }
    });
}); };
export var getRepairTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'repairTypeList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? repairTypeListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
